(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');
  let listeningForScroll = false;
  let observedHeader;

  const headerResizeObserver = new ResizeObserver(() => {
    updateHeaderState();
  });

  const updateHeaderState = () => {
    const header = document.querySelector('.section-header');

    if (!header) return;

    if (header !== observedHeader) {
      if (observedHeader) {
        headerResizeObserver.unobserve(observedHeader);
      }

      observedHeader = header;
      headerResizeObserver.observe(header);
    }

    if (desktopMedia.matches) {
      const headerHeight = `${header.getBoundingClientRect().height}px`;

      if (header.style.getPropertyValue('--lt-header-height') !== headerHeight) {
        header.style.setProperty('--lt-header-height', headerHeight);
      }
    } else {
      header.style.removeProperty('--lt-header-height');
    }

    const shouldBeSolid = desktopMedia.matches && window.scrollY > 0;

    if (header.classList.contains('scrolled-past-header') !== shouldBeSolid) {
      header.classList.toggle('scrolled-past-header', shouldBeSolid);
    }
  };

  const updateViewportMode = () => {
    if (desktopMedia.matches && !listeningForScroll) {
      window.addEventListener('scroll', updateHeaderState, { passive: true });
      listeningForScroll = true;
    }

    if (!desktopMedia.matches && listeningForScroll) {
      window.removeEventListener('scroll', updateHeaderState);
      listeningForScroll = false;
    }

    updateHeaderState();
  };

  desktopMedia.addEventListener('change', updateViewportMode);
  document.addEventListener('shopify:section:load', updateHeaderState);
  updateViewportMode();
})();
